import { frontendURL } from '../../../helper/URLHelper';
import RentFlowsIndex from './pages/RentFlowsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tenants/rentFlows'),
    alias: [
      frontendURL('accounts/:accountId/propostas'),
      frontendURL('accounts/:accountId/proposals'),
      frontendURL('accounts/:accountId/sale-offers'),
      frontendURL('accounts/:accountId/rent-offers'),
      frontendURL('accounts/:accountId/ofertas'),
      frontendURL('accounts/:accountId/property_offers'),
    ],
    name: 'lais_tenants_rent_flows',
    component: RentFlowsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/propostas/:offerStatus'),
    alias: [
      frontendURL('accounts/:accountId/tenants/rentFlows/:offerStatus'),
      frontendURL('accounts/:accountId/proposals/:offerStatus'),
      frontendURL('accounts/:accountId/sale-offers/:offerStatus'),
      frontendURL('accounts/:accountId/rent-offers/:offerStatus'),
      frontendURL('accounts/:accountId/ofertas/:offerStatus'),
      frontendURL('accounts/:accountId/property_offers/:offerStatus'),
    ],
    name: 'lais_tenants_rent_flows_status',
    component: RentFlowsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL(
      'accounts/:accountId/propostas/:offerStatus/:rentProgressPhase'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/tenants/rentFlows/:offerStatus/:rentProgressPhase'
      ),
      frontendURL(
        'accounts/:accountId/proposals/:offerStatus/:rentProgressPhase'
      ),
      frontendURL(
        'accounts/:accountId/sale-offers/:offerStatus/:rentProgressPhase'
      ),
      frontendURL(
        'accounts/:accountId/rent-offers/:offerStatus/:rentProgressPhase'
      ),
    ],
    name: 'lais_tenants_rent_flows_status_phase',
    component: RentFlowsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
